"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var msg = require("console-tags.js/src/console-tags.js");
var carousel_1 = require("@/components/carousel");
var init = function () {
    msg.success("HomeController", "Ready!");
    (0, carousel_1.Carousel)();
};
exports.default = init;
